import { Accordion, AccordionSummary, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material'
import { ResponsiveCell, Row, SectionHeader, SectionWrapper } from '../../../components/tableComponents'
import { IGroup, INestedObject } from '../../../types/snapshot'
import { useState } from 'react'
import { ExpandMore } from '@mui/icons-material'
import BasicTabs from '../../../components/BasicTabs'


type props = {
    groups: IGroup[]
}

const SnapshotGroupsTab = ({groups}: props) => {
    const [expanded, setExpanded] = useState<string | false>(false);

    const handleChange = (panel: string) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };

  return (
    <>
        {
            groups.map(
                (group) => {
                    return (
                        <Accordion expanded={expanded === group.id} key={group.id} onChange={handleChange(group.id)}>
                            <AccordionSummary expandIcon={<ExpandMore/>} aria-controls="panel1bh-content" id="panel1-header">
                                <Typography 
                                    sx={{
                                        width: {xs: "33%", md: "20%"},
                                        overflow: {xs: "hidden"},
                                        textOverflow: {xs: "ellipsis"},
                                        whiteSpace: {xs: "nowrap"},
                                    }} 
                                >
                                    {group.name}
                                </Typography>
                                <Typography 
                                    sx={{
                                        width: '33%',
                                        flexShrink: 0, 
                                        overflow: {xs: "hidden"},
                                        textOverflow: {xs: "ellipsis"},
                                        whiteSpace: {xs: "nowrap"},
                                    }} 
                                >
                                    {group.id}
                                </Typography>
                                <Typography 
                                    sx={{
                                        width: {md: "15%"}, 
                                        display: {xs: "none", md: "flex"},
                                        flexShrink: 0,
                                        overflow: {xs: "hidden"},
                                        textOverflow: {xs: "ellipsis"},
                                        whiteSpace: {xs: "nowrap"},
                                    }} 
                                >
                                    {`U: ${group.nestedUsers? group.nestedUsers?.length : 0}`}
                                </Typography>
                                <Typography sx={{
                                        display: {xs: "none", md: "flex"},
                                        width: {md: "15%"},  
                                        flexShrink: 0,
                                        overflow: {xs: "hidden"},
                                        textOverflow: {xs: "ellipsis"},
                                        whiteSpace: {xs: "nowrap"},
                                    }} 
                                >
                                    {`P: ${group.nestedPolicies? group.nestedPolicies?.length : 0}`}
                                </Typography>
                            </AccordionSummary>

                            <BasicTabs children={[
                                {
                                    label: 'Users',
                                    content: <>
                                        <SectionWrapper>
                                            <Table  aria-label="snapshot assets table">
                                                <SectionHeader title="Users" />
                                                <TableBody>
                                                    {group.nestedUsers?.map((object) => 
                                                        (
                                                            <Row 
                                                                key={object.id} 
                                                                field={object.object.profile[0].value} 
                                                                value={object.id} boldProperty hasCopyOption 
                                                                helperText={JSON.stringify(object)} 
                                                                route={`/snapshots/${object.id}`} 
                                                            />
                                                        )
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </SectionWrapper>
                                    </>,
                                },
                                {
                                    label: 'Policies',
                                    content: <>
                                        <SectionWrapper>
                                            <Table  aria-label="snapshot assets table">
                                                <SectionHeader title="Policies" />
                                                <TableBody>
                                                    {group.nestedPolicies?.map((object) => 
                                                        (
                                                            <Row 
                                                                key={object.id} 
                                                                field={object.name} 
                                                                value={object.id} 
                                                                boldProperty 
                                                                helperText={JSON.stringify(object)} 
                                                            />
                                                        )
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </SectionWrapper>
                                    </>,
                                },
                            ]}/>
                        </Accordion>
                    )
                }
            )
        }
    </>
  )
}

export default SnapshotGroupsTab